export default "__VITE_ASSET__ByryelKH__"